<header class="account__setup--header">
  <span class="app__form--attribute--title font-semibold text-base">Onboarding Responsibilities </span>
  <button matTooltipPosition="above" data-dismiss="modal" class="bg-white" (click)="closeSideNav()">
    <span class="material-icons relative bg-white">clear</span>
  </button>
</header>

<section class="flex" [style]="screenWidth > 480 ? 'height: 90vh' : 'margin-bottom: 60px'">
  @if (screenWidth > 480) {
  <div class="nav w-[253px]">
    <nav class="w-full">
      <ul class="w-full pt-5">
        @for (step of steps; track step; let index = $index; let last = $last) {
        <li
          class="app__stepper__config-stepitem"
          [class]="step.completed ? 'hover:text-[#1AA140] cursor-default' : ''"
          [ngClass]="{
            'app__stepper__config-stepitem-completed': step.completed,
            'app__stepper__config-stepitem-notcompleted': !step.completed,
            'app__stepper__config-stepitem-selected  app__network--setup-selected': step.status == 'active',
            hidden: index == 0 && switchFromUser
          }"
          (click)="handleSidenavMenuNavigation(index)"
        >
          @if (step.completed) {
          <img class="app__stepper__image-checked" src="../../../../assets/images/check-green.svg" alt="green-check" />
          }
          {{ step.title | titlecase }}
        </li>
        }
      </ul>
    </nav>
  </div>
  }

  <div class="pr-0" [ngClass]="{ 'account__setup--body ': !isImpersonating, 'account__setup-impersonating-body': isImpersonating }" style="padding: 2em 0 0 2em;">
    <!-- Set Up Two Factor Authentication -->
    <div
      [ngClass]="{
        'h-full flex flex-col justify-between': true
      }"
    >
      <div class="h-[85.5%] max-h-[85.5%] overflow-y-auto">
        @if(currentActiveIndex === 0){
        <instruction-setup
          style="margin-right: 42px; display: block"
          [setupInstructions]="setupInstructions"
          [title]="'Onboarding Responsibilities'"
        ></instruction-setup>
        } @else if(currentActiveIndex === 2){
        <div class="mr-[42px]">
          <div class="rounded-xl min-h-60 w-full border bg-white flex items-center justify-center flex-col py-8 px-12 mt-4">
            <p
              [class]="
                screenWidth > 480
                  ? 'sm:mb-2 text-xl text-center  text-[#53565B] font-semibold'
                  : 'sm:mb-[8px] text-xl leading-5 text-center text-[#53565B] font-semibold'
              "
            >
              Mark
              <span class="font-weight-bold-blue">Onboarding Responsibilities </span>
              as complete?
            </p>
            <!-- <p class="text-sm text-center px-13 text-[#18191C]">
              You can manage vault membership settings at any point in the future from the vault section of this account.
            </p> -->

            <div class="flex mt-10">
              <app-button-slide (isSubmitButtonActiveForSubMit)="submitAllFormAnswers($event)"></app-button-slide>
            </div>
            <div class="app__mark--complete--info">
              <img src="../../../../assets/images/mark-as-complete-info.svg" alt="mark-complete-info" />
              <span class="app__form--attribute--title">
                You can manage permissions at any point in the future through the network page of this account.
              </span>
            </div>
          </div>
        </div>
        }  @else if(currentActiveIndex >= 1 ){
          @if(!guardianList){

       <div class="m-0 text-xl text-[#53565b] flex items-start flex-col pb-6">
          <p [class]="screenWidth > 480 ? 'sm:mb-2 font-semibold' : 'sm:mb-[8px] text-sm leading-5'">
              Onboarding Responsibilities for  <span class="font-weight-bold-blue">{{currentUser.nick_name}} </span> 
            </p>
            <span class="app__form--attribute--title text-[12px] font-normal leading-[16.34px] text-[#18191C]">Identify all users whom {{currentUser.nick_name}} will be fully or partially responsible for onboarding.</span>
              <div class="app__itemCard w-[97%] min-h-fit max-h-[300px] justify-start h-fit text-center items-center" >
                  <img src="../../../../../assets/images/crunch-banner.gif" width="30%" height="30%" >
                  <p>One moment while we check your permissions</p>
              </div>   
       </div>}@else{
       <my-responsibilities [filteredSuggestedVaults]="filteredSuggestedVaults" [filteredUserVaults]="filteredUserVaults" [currentUser]="currentUser"
       (addUserDetails)="handleaddUserDetails($event)" (createUserDetails)="handleCreateUserDetails($event)" (deleteUserDetails)="(handleDeleteUserDetails($event))"></my-responsibilities>
       }
        } 
      </div>
      <div class="relative w-full flex flex-col pr-[42px]">
        <mat-divider class="text-[#C1C2C5] w-full"></mat-divider>
        <div
          class="edit__profile-footer-transparent pt-0 items-center px-10"
          [ngClass]="{
            'justify-between': currentActiveIndex === 1
          }"
          [ngStyle]="{
            'justify-content': currentActiveIndex === 2 ? ' flex-start' : ''
          }"
        >
          @if (currentActiveIndex > 0 && currentActiveIndex <= 2) {
          <button class="bg-transparent cursor-pointer flex items-center font-bold text-xs gap-2" (click)="gotoPrevious()">
            <span class="flex items-center gap-2 text-[#18191C]"
              ><span class="material-icons text-base"> arrow_back</span>
              <span class="text-sm font-semibold"> Back </span>
            </span>
          </button>
          } @if (currentActiveIndex < 2) {
          <button
            style="height: 48px; margin-bottom: 12px"
            class="app__btn--primary w-fit min-w-[158px] py-3 px-8 mt-5"
            (click)="
              currentActiveIndex === 2 && markAsComplete
                ? completeSetup()
                : currentActiveIndex === 2 && !markAsComplete
                ? closeSideNav()
                : handleSidenavMenuNavigation()
            "
          >
            Continue
          </button>
          }
        </div>
      </div>
    </div>

    @if (showLoader) {
    <div>
      <div class="loading-spinner loader-overlay">
        <mat-spinner></mat-spinner>
      </div>
    </div>
    }
  </div>
</section>
